<template>
<a v-if="href" :class="className" :href="href">
    <span :class="bem('content')">
        <!-- 文本内容 -->
        <slot/>
    </span>
</a>
<button
    v-else
    :class="className"
    :disabled="disabled"
    @click="click"
    :type="nativeType">
    <span :class="bem('content')">
        <!-- 文本内容 -->
        <slot/>
    </span>
</button>

</template>
<script>
import {bemMixin} from "../utils";
export default {
  name: "g-btn",
  mixins: [bemMixin],
  props: {
    size: {
      type: String,
      default: "normal"
    },
    type: {
      type: String,
      default: "normal"
    },
    href: {
      type: String,
      default: ""
    },
    disabled: {type: Boolean, default: false},
    nativeType: {
      type: String,
      default: "button"
    }
  },
  data() {
    return {
      active: false
    };
  },
  computed: {
    className() {
      return this.bem({
        [this.size]: this.size !== "normal",
        [this.type || "normal"]: true,
        active: this.active,
        disabled: this.disabled,
        loading: this.loading
      });
    }
  },
  methods: {
    click(e) {
      if (this.disabled)
        return;
      clearTimeout(this.timeout);
      this.active = true;
      this.timeout = window.setTimeout(() => {
        this.active = false;
      }, 200);
      this.$emit("click", e);
    }
  }
};

</script>
<style>
.g-btn {
  padding: 0 16px;
  border-radius: 4px;
  line-height: 38px;
  font-size: 14px;
  color: #444950;
  user-select: none;
  font-weight: bold;
  white-space: nowrap;
  background: #fff;
  cursor: pointer;
  background-image: none;
  touch-action: manipulation;
  border: 1px solid #dadde1;
  box-sizing: border-box;
  display: inline-block;
  outline: 0;
  transition: color 0.15s linear, background-color 0.15s linear, border 0.15s linear;
  text-decoration: none;
}
.g-btn--flat:hover,
.g-btn--text:hover,
.g-btn--secondary:hover,
.g-btn--normal:hover {
  background-color: #e0e5ea;
}
.g-btn--flat.g-btn--active,
.g-btn--text.g-btn--active,
.g-btn--secondary.g-btn--active,
.g-btn--normal.g-btn--active {
  outline: 0;
  background-color: #dadde1;
}
.g-btn--flat[disabled],
.g-btn--text[disabled],
.g-btn--secondary[disabled],
.g-btn--normal[disabled] {
  background-color: #ffffff;
  opacity: 0.38;
  cursor: no-drop;
}
.g-btn--text,
.g-btn--flat {
  border-color: transparent;
}
.g-btn--primary {
  background-color: #2254f4;
  border-color: #2254f4;
  color: #ffffff;
  font-weight: bold;
}
.g-btn--primary:hover {
  color: #ffffff;
  background-color: #3865f6;
  border-color: #3865f6;
}
.g-btn--primary.g-btn--active {
  background-color: #143292;
  border-color: #143292;
}
.g-btn--primary[disabled] {
  background-color: #2254f4;
  border-color: #2254f4;
  opacity: 0.38;
  color: #ffffff;
  cursor: no-drop;
}
.g-btn--secondary {
  background-color: #f0f3f4;
  border-color: transparent;
}
.g-btn--danger {
  background-color: #de415c;
  border-color: #de415c;
  color: #ffffff;
}
.g-btn--danger:hover {
  background-color: #ee9caa;
  border-color: #ee9caa;
}
.g-btn--danger.g-btn--active {
  background-color: #852737;
  border-color: #852737;
}
.g-btn--danger[disabled] {
  background-color: #de415c;
  border-color: #de415c;
  opacity: 0.38;
  color: #ffffff;
  cursor: no-drop;
}
.g-btn--text {
  border: none;
  color: #444950;
  height: auto;
  font-weight: normal;
  padding: 0;
  line-height: 36px;
}
.g-btn--text:not([disabled]):hover {
  color: #000000;
  background-color: transparent;
}
.g-btn--text:not([disabled]).g-btn--active {
  color: #000000;
  background-color: transparent;
}
.g-btn--mini {
  padding: 0 8px;
  line-height: 22px;
  font-size: 12px;
}
.g-btn--small {
  padding: 0 12px;
  line-height: 30px;
}
.g-btn--large {
  line-height: 48px;
  padding: 0 20px;
}
.g-btn--huge {
  line-height: 50px;
  font-size: 16px;
  padding: 0 24px;
}
.g-btn--loading {
  pointer-events: none;
}
.g-btn[disabled].g-btn--text {
  background: none;
  border: none;
}
.g-btn__content {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
